
import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';
import UploadLogotype from './upload-logotype/upload-logotype';
import { Profession, GeneralError, SpinnerButton, ConfirmModal } from 'components';
import { UserService, LogotypeService, Utils } from 'frilans-finans';

export class OwnEmployment extends React.Component {

  static contextTypes = {
    user: PropTypes.object.isRequired
  };

  constructor (props, context) {
    super(props, context);

    this.state = {
      showErrorWithoutBlur: false,
      user: this.getUserObject(context.user),
      logotype: null,
      posting: false,
      updated: false,
      postError: false,
      postLogotypeError: false,
      renderLogotypeDeleteConfirmModal: false,
      logotypePreview: false,
      message: null,
      logotypeDeleted: false
    };

    this.callback = this.callback.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.clickSubmit = this.clickSubmit.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.handleError = this.handleError.bind(this);
    this.setLogotype = this.setLogotype.bind(this);
    this.deleteLogotype = this.deleteLogotype.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleLogotypeSuccess = this.handleLogotypeSuccess.bind(this);
    this.handleLogotypeError = this.handleLogotypeError.bind(this);
  }

  getUserObject (user) {
    let userObj = Utils.getInputValueObjects(user);

    return {
      id: userObj.id,
      professionTitle: userObj.professionTitle,
      professionID: userObj.professionId,
      displayHsd: userObj.displayHsd,
      saveITP: userObj.saveITP,
      itpRate: userObj.itpRate,
      saveVacationPay: userObj.saveVacationPay,
      defaultTaxkeyId: userObj.defaultTaxkeyId,
      receiveSmsNotifications: userObj.receiveSmsNotifications,
      receiveEmailNotifications: userObj.receiveEmailNotifications,
      imageSrc: userObj.imageSrc,
      socialSecurityNr: userObj.socialSecurityNr
    };
  }

  setLogotype (logotype) {
    this.setState({logotype});
  }

  callback (name, values) {
    var tempFormValues = this.state.user;

    Object.assign(tempFormValues[name], values);
    this.setState({user: tempFormValues});
  }

  handleClick (e) {
    let name;
    let values = {};

    name = e.target.name;
    values[name] = {
      value: e.target.checked
    };

    this.callback(name, values[name]);
  }

  /**
   * Required function when you have the checked attribute on a checkbox
   */
  onChange (e) {}

  submitForm () {
    const user = this.state.user;
    var params = Utils.getPostParams(user);
    params.professionId = user.professionTitle.id
      ? parseInt(user.professionTitle.id)
      : user.professionId;

    UserService.update(params)
      .then(this.handleSuccess)
      .catch(this.handleError);

    this.setState({
      posting: true,
      updated: false,
      postError: false
    });
  }

  submitLogotypeAndForm (callback) {
    let reader = new FileReader();
    let self = this;

    reader.onload = function (e) {
      LogotypeService.post({
        'user_id': self.state.user.id.value,
        'image': e.target.result
      }).then(self.handleLogotypeSuccess)
        .catch(self.handleLogotypeError)
        .then(function () {
          if (typeof callback === 'function') {
            callback();
          }
        });
    };

    reader.readAsDataURL(this.state.logotype);
  }

  clickSubmit (e) {
    e.preventDefault();

    if (Utils.validateInputValues(this.state.user)) {
      if (this.state.logotype) {
        this.submitLogotypeAndForm(this.submitForm);
      } else {
        this.submitForm();
      }
    } else {
      this.setState({showErrorWithoutBlur: true});
    }
  }

  handleSuccess () {
    this.setState({
      posting: false,
      updated: true,
      postError: false
    });

    this.showMessage('SETTINGS_UPDATED');
  }

  handleError () {
    this.setState({
      posting: false,
      updated: false,
      postError: true
    });
  }

  handleLogotypeSuccess () {
    this.setState({
      logotype: null,
      logotypePreview: false,
      logotypeDeleted: false
    });
  }

  handleLogotypeError () {
    this.setState({
      postLogotypeError: true
    });
  }

  renderSuccessMessage () {
    if (this.state.message != null) {
      return (
        <p className='info'><Translate content={this.state.message} /></p>
      );
    }
  }

  showMessage (message) {
    this.setState({
      message: message
    });
  }

  deleteLogotype = (e) => {
    this.setState({
      renderLogotypeDeleteConfirmModal: true
    });
    e.preventDefault();
  }

  renderLogotypeDeleteConfirmModal () {
    if (this.state.renderLogotypeDeleteConfirmModal) {
      return (
        <ConfirmModal
          callback={this.closeModal}
          message={proxyCounterpart('SETTINGS_CONFIRM_LOGOTYPE_DELETE')}
        />
      );
    }
  }

  closeModal (confirm) {
    if (confirm) {
      LogotypeService.delete({
        'user_id': this.state.user.id.value
      }).then(() => {
        this.setState({
          logotype: null,
          logotypeDeleted: true
        });

        this.showMessage('SETTINGS_LOGOTYPE_DELETED');
      }).catch(this.handleLogotypeError);
    }

    this.setState({
      renderLogotypeDeleteConfirmModal: false
    });
  }

  render () {
    var postError, postLogotypeError, imageSrc;

    postError = this.state.postError ? (<GeneralError />) : false;
    postLogotypeError = this.state.postError ? (<GeneralError />) : false;
    imageSrc = this.state.user.imageSrc ? this.state.user.imageSrc.value : false;

    return (
      <div className='own-employment'>
        <h2><Translate content='EMPLOYMENT_INVOICE'/></h2>
        <form>

          <Profession value={this.state.user.professionTitle.value || ''} name='professionTitle'
            showErrorWithoutBlur={this.state.showErrorWithoutBlur} callback={this.callback} />

          <div className="section">
            <h3>
              <Translate content='ROT_RUT'/>
              <a
                href='https://www.frilansfinans.se/fragor-och-svar/rut-och-rot-avdrag/'
                target='_blank'
              ><Translate content='OWN_EMPLOYMENT_READ_MORE'/>
              </a>
            </h3>
            <div className='styled-wrapper right'>
              <input id='displayHsd' type='checkbox' name='displayHsd' onChange={this.onChange}
                value={this.state.user.displayHsd.value}
                checked={this.state.user.displayHsd.value} onClick={this.handleClick} />
              <label htmlFor='displayHsd'>
                <span></span>
                <Translate content='ACTIVATE_ROT_RUT'/>
              </label>
            </div>
          </div>

          <UploadLogotype imageSrc={imageSrc} setLogotype={this.setLogotype}
            deleteLogotype={this.deleteLogotype} logotypePreview={this.state.logotypePreview}
            logotypeDeleted={this.state.logotypeDeleted}/>

          {this.renderSuccessMessage()}
          {postError}
          {postLogotypeError}

          <div className='button-wrapper'>
            <SpinnerButton text={proxyCounterpart('SAVE_SETTINGS')}
              loading={this.state.posting} type='button' classes='btn' callback={this.clickSubmit}/>
          </div>

        </form>

        {this.renderLogotypeDeleteConfirmModal()}

      </div>
    );
  }
}

export default OwnEmployment;



/** WEBPACK FOOTER **
 ** ./src/views/settings/own-employment/own-employment.js
 **/